<template>
	<li
		:class="{
			[styles.air__menuLeft__item]: true,
			[styles.air__menuLeft__submenu]: true,
			[styles.air__menuLeft__submenu__active]: item.key === activeSubmenu
		}"
	>
		<a
			href="javascript: void(0);"
			:class="styles.air__menuLeft__link"
			@click="() => handleSubmenuClick(item.key)"
			@mouseenter="(event) => handleFlyoutOver(event, item.key, item.children)"
			@mouseleave="handleFlyoutOut(item.key)"
		>
			<fa-icon
				v-if="item.icon"
				:icon="item.icon"
				:class="{[item.icon]: true,[styles.air__menuLeft__icon]: true}"
			/>
			<span>{{ item.title }}</span>
		</a>
		<ul :class="styles.air__menuLeft__list">
			<template v-for="(sitem, index) in item.children">
				<item
					v-if="!sitem.children
						&& !sitem.category
						&& $gestios.auth.check({scopes: sitem.auth.roles, strict: sitem.auth.strict})
					"
					:key="index"
					:item="sitem"
					:styles="styles"
					:active-item="activeItem"
				/>
			</template>
		</ul>
	</li>
</template>

<script>
import Item from './item';

export default {
	name: 'SubMenu',
	components: { Item },
	props: {
		item: Object,
		styles: Object,
		activeSubmenu: String,
		activeItem: String,
		handleSubmenuClick: Function,
		handleFlyoutOver: Function,
		handleFlyoutOut: Function
	}
};
</script>
